<template #content>

    <div class="w-full">
        <!-- <div class="field mt-4 flex gap-2">
            <div class="w-full">
                <FileUpload ref="upload" name="arquivo[]" :url="uploadUrl()" chooseIcon="pi pi-file-plus" :multiple="true"
                    chooseLabel="Selecionar" uploadLabel="Upload" @before-send="beforeUpload" @upload="onUploaded"
                    @error="onUploadError" :maxFileSize="50000000">
                    <template #empty>
                        <div class="text-center">
                            <div class="text-gray-600">
                                Arraste o arquivo aqui para fazer o upload.<br>
                                <i class="pi pi-cloud-upload text-6xl"></i>
                            </div>
                        </div>
                    </template>
                </FileUpload>
            </div>
        </div> -->

        <Fieldset legend="Upload de Arquivo">
            <!-- Toolbar com Botão -->
            <BlockUI :blocked="isLoadingInstalacao" class="relative w-full px">
                <Toolbar>
                    <template #end>
                        <div class="flex gap-1">
                            <Button
                                label="Selecionar Arquivo"
                                icon="pi pi-folder-open"
                                severity="primary"
                                @click="openFileDialogInstalacao"
                            />
                            <Button
                                label="Enviar"
                                icon="pi pi-upload"
                                severity="success"
                                :loading="isLoadingInstalacao"
                                @click="handleUploadInstalacao"
                            />
                            <Button
                                label="Limpar"
                                icon="pi pi-trash"
                                severity="danger"
                                @click="clearFileDialogInstalacao"
                            />
                        </div>
                    </template>
                </Toolbar>

                <div class="field mt-4">
                    <FilePond
                        ref="pondInstalacao"
                        name="arquivo[]"
                        labelIdle='Arraste o arquivo ou <span class="filepond--label-action">clique aqui</span>'
                        acceptedFileTypes="image/*"
                        :files="filesInstalacao"
                        @updatefiles="onFileUpdateInstalacao"
                        :allowMultiple="true"
                        :instantUpload="false"
                    />
                </div>

                <div v-if="isLoadingInstalacao" class="absolute" style="top: calc(50% - 20px); left: calc(50% - 20px);">
                    <ProgressSpinner style="width: 40px; height: 40px" strokeWidth="6" />
                    <!-- <i class="pi pi-spinner pi-spin text-4xl text-blue-100"></i> -->
                </div>
            </BlockUI>
        </Fieldset>




        <div class="w-full">
            <Toolbar class="mb-2 bg-gray-100">
                <template #start>
                    <div class="font-semibold">Evidencias</div>
                </template>
                <template #end>
                    <div class="flex items-center gap-1">
                        <Button icon="pi pi-refresh" label="Atualizar" severity="warn" size="small" @click="loadData" />
                    </div>
                </template>
            </Toolbar>

            <DataTable :value="lista" :loading="isLoading" size="small" stripedRows showGridlines scrollable
                scrollHeight="calc(100vh - 300px)" :sortField="params.sort.field" :sortOrder="params.sort.order"
                @sort="onTableSort">

                <Column style="width: 100px" field="id" header="#" sortable></Column>
                <Column field="nome" header="nome" sortable></Column>
                <Column field="created_at" header="Criação" sortable>
                    <template #body="{ data }">
                        {{ dateFormat(data.created_at) }}
                    </template>
                </Column>

                <Column style="width: 120px" bodyClass="flex justify-content-end gap-1">
                    <template #body="{ data }">
                        <Button icon="pi pi-download" title="Baixar" severity="primary" size="small"
                            @click="download(data)" />
                        <Button icon="pi pi-eye" title="Visualizar" severity="secondary" size="small"
                            @click="visualizar(data)" />
                        <Button icon="pi pi-trash" title="Remover" severity="danger" size="small"
                            @click="remove(data.id, true)" />
                    </template>
                </Column>

                <template #empty>
                    <div class="text-center text-gray-600">
                        Nenhum registro encontrado
                    </div>
                </template>
            </DataTable>

            <div class="flex justify-content-between flex-wrap">
                <div class="flex align-items-center justify-content-center">
                    <div class="flex justify-end mt-2 text-sm text-gray-600">
                        <span>{{ pagination.total }} registros</span>
                    </div>
                </div>
                <div class="flex align-items-center justify-content-center">
                    <Paginator :first="pagination.first" :rows="pagination.perPage" :totalRecords="pagination.total"
                        @page="onPage">
                    </Paginator>
                </div>
                <div class="flex align-items-center justify-content-center">
                </div>
            </div>
        </div>

    </div>

</template>
<script>

/* Table */
import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Paginator from 'primevue/paginator';
import Column from 'primevue/column';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import FileUpload from 'primevue/fileupload';

import vueFilePond from 'vue-filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
const FilePond = vueFilePond(FilePondPluginFileValidateType)
import ProgressSpinner from 'primevue/progressspinner';
import BlockUI from 'primevue/blockui';
import Fieldset from 'primevue/fieldset';

import Popover from 'primevue/popover';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';

import Evidencia from '@/service/evidencia.js';
import Arquivo from '@/service/arquivo.js';

import Token from '@/utils/Token';
import File from '@/utils/File';

import Moment from 'moment';
import Filter from '@/utils/Filter.js';

export default {
    components: {
        Toolbar,
        Button,
        DataTable,
        Paginator,
        Column,
        InputGroup,
        InputGroupAddon,
        FilePond,
        ProgressSpinner,
        BlockUI,
        Fieldset,

        /* Busca */
        Popover,
        FloatLabel,
        InputText,
        FileUpload,
    },
    props: {
        contrato: {},
        permissoes: {},
    },
    emits: ['save'],
    data() {
        return {
            isLoading: false,
            lista: [],
            item: {},
            visibleForm: false,

            filesInstalacao: [],
            isLoadingInstalacao: false,

            params: {
                filter: {},
                sort: {
                    field: 'id',
                    order: -1
                }
            },
            pagination: {
                page: 0,
                perPage: 0,
                total: 0,
            },

        }
    },
    mounted() {
        this.loadData();
    },
    methods: {

        // Instalação
        onFileUpdateInstalacao(files) {
            this.filesInstalacao = files.map(file => file.file)
        },
        openFileDialogInstalacao() {
            this.$refs.pondInstalacao.browse()
        },
        clearFileDialogInstalacao() {
            this.filesInstalacao= []
        },

        async handleUploadInstalacao() {

            if (this.filesInstalacao.length === 0) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'Nenhum arquivo selecionado',
                    life: 5000
                })
                return
            }

            this.isLoadingInstalacao = true

            const formData = new FormData()
            this.filesInstalacao.forEach(file => {
                formData.append('arquivo[]', file)
            })

            try {
                // const response = await Arquivo.contaCarne(this.form.contrato_id, formData)
                const response = await Arquivo.contratoEvidencia(this.contrato.id, formData)

                this.filesInstalacao = []

                this.$toast.add({
                    severity: 'success',
                    summary: 'Sucesso',
                    detail: `Evidência incluído com sucesso.`,
                    life: 3000
                })

                this.$emit('save', response.data);
                this.loadData()


            } catch (error) {
                if (error.response?.data?.erros) {
                    this.errors = error.response.data.erros
                } else if (error.response?.data?.msg) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: error.response.data.msg,
                        life: 10000
                    })
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Erro ao realizar upload',
                        life: 5000
                    })
                }
            } finally {
                this.isLoadingInstalacao = false
            }
        },


        uploadUrl() {
            return Arquivo.contratoEvidencia(this.contrato.id);
        },
        beforeUpload(request) {
            let token = Token.get();
            request.xhr.setRequestHeader('Authorization', `Bearer ${token}`);
            // pode incluir dados no upload
            return request;
        },
        onUploadError(event) {
            let error = JSON.parse(event.xhr.response);
            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.msg, life: 5000 });
        },
        onUploaded(event) {
            this.$refs.upload.clear();
            this.$refs.upload.uploadedFileCount = 0;

            let data = JSON.parse(event.xhr.response);
            this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'O arquivo foi enviado com sucesso.', life: 3000 });
            this.$emit('save', data);

            this.loadData();
        },
        dateFormat(value) {
            if (!value) return;
            return Moment(value).format("DD/MM/YYYY HH:mm");
        },
        visualizar(data) {
            Arquivo.view(data.id)
                .then(response => {
                    File.openWindow(response);
                });
        },
        download(data) {
            Arquivo.view(data.id)
                .then(response => {
                    File.download(response);
                });
        },
        openForm(item) {
            this.item = { ...item };
            this.visibleForm = true;
        },
        closeForm(event) {
            this.item = {};
            this.visibleForm = false;
        },
        saveForm(arquivo = null) {
            this.$emit('save', arquivo);
            this.loadData();
        },
        remove(arquivoID, versao = false) {
            this.$confirm.require({
                message: 'Deseja realmente remover o item?',
                header: 'Remover',
                acceptLabel: 'Remover',
                icon: 'pi pi-trash',
                acceptClass: 'bg-red-500 text-white border-red-500',
                rejectLabel: 'Cancelar',
                rejectClass: 'bg-red-400 text-white',
                accept: () => {
                    this.isLoading = true;
                    Arquivo.delete(arquivoID)
                        .then(response => {
                            this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'O item foi removido com sucesso.', life: 3000 });
                            if (versao) {
                                this.loadData();
                            } else {
                                this.saveForm({});
                            }
                        })
                        .catch(error => {
                            if (error.response) {
                                let err = error.response.data;
                                if (err.erros) {
                                    for (let i in err.erros) {
                                        this.errors[i] = err.erros[i][0];
                                    }
                                    return;
                                }
                                if (error.response.data.msg) {
                                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                                    return;
                                }
                            }
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                },
            });
        },
        loadDataParams() {
            let params = [];

            // Pagination
            params.push(`page=${1 + this.pagination.page}`);

            // Filter
            params = Filter.formToQuery(this.params.filter, params);

            // Order
            params.push(`order[${this.params.sort.field}]=` + (this.params.sort.order > 0 ? 'asc' : 'desc'));
            return params;
        },
        loadData() {
            let params = this.loadDataParams();

            this.isLoading = true;
            Evidencia.listContrato(this.contrato.id, params.join("&"))
                .then(response => {
                    this.lista = response.data.data;
                    this.pagination.perPage = response.data.per_page;
                    this.pagination.total = response.data.total;
                    this.pagination.first = response.data.per_page * this.pagination.page;
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        // Paginate
        onPage(event) {
            const page = event ? event.page : 0;
            this.pagination.page = page;
            this.loadData();
        },

        // Sort
        onTableSort(event) {
            this.params.sort = {
                field: event.sortField,
                order: event.sortOrder,
            };
            this.loadData();
        },
    }
}
</script>

<style>
.contrato-endereco .p-panel-header {
    padding-bottom: 0;
}
</style>
